var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "flat-switch-content" },
    [
      _c(
        "h1",
        {
          staticClass:
            "subtitle has-text-weight-bold has-text-primary is-size-5"
        },
        [
          _vm._v(
            "\n      Deseja realizar a cotação com qual tipo de tabela ?\n  "
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flat-switch" },
        [
          _c("p", { staticClass: " is-size-10 p-switch" }, [
            _vm._v(" " + _vm._s("Vigente"))
          ]),
          _vm._v(" "),
          _c(
            "sc-field",
            [
              _c("sc-switch", {
                attrs: { value: _vm.status },
                on: { input: _vm.toggleCommit }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("p", { staticClass: " is-size-10" }, [
            _vm._v(" " + _vm._s("Rascunho") + " ")
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c("sc-collapse", [
        _c(
          "div",
          {
            staticClass: "panel-heading",
            attrs: {
              slot: "trigger",
              role: "button",
              "aria-controls": "contentIdForA11y2"
            },
            slot: "trigger"
          },
          [
            _c("sc-icon", {
              staticClass: "additional-information__icon",
              attrs: { icon: "info-circle", size: "is-small" }
            }),
            _vm._v(" "),
            _c("strong", [_vm._v("O que é isso ?")])
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "panel-block" }, [
          _c("p", [
            _vm._v(
              "\n         Utilize essa funcionalidade para realizar cotações \n         com tabelas que ainda estão em processo de validação \n         diretamente na conta a qual o contrato foi importado. "
            ),
            _c("br"),
            _vm._v(
              "\n         Basta selecionar com qual status deseja cotar: "
            ),
            _c("br"),
            _vm._v(" "),
            _c("i", { staticClass: "fas fa-circle" }),
            _vm._v("Vigente: Tabelas já validadas e vigentes no sistema "),
            _c("br"),
            _vm._v(" "),
            _c("i", { staticClass: "fas fa-circle" }),
            _vm._v(
              "Rascunho: Tabelas em processo de teste que ainda não foram validadas\n      "
            )
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6e54200a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e54200a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-quote/features/freight-quote/components/sc-logistic-draft/ScLogisticDraft.vue
// module id = null
// module chunks = 